// extracted by mini-css-extract-plugin
export default {"tag":"SuggestTagsCard_tag__1DUZD","remove":"SuggestTagsCard_remove__snlPQ","label":"SuggestTagsCard_label__X9kYA"};